import {useFeatureAppEnvironment} from '../contexts/feature-app-environment-context';

export function useFeatureAppId(): string {
  const {featureAppId} = useFeatureAppEnvironment();

  return featureAppId;
}
